import { Helmet } from 'react-helmet';

import { IonText } from '@ionic/react';

import styles from './Home.module.scss';

import { APP_TITLE } from '../../constants/app';
import { GitLiveLogo } from '../../stories/GitLiveLogo/GitLiveLogo';

export default function Home() {
  return (
    <section className={styles.container}>
      <Helmet>
        <title>{APP_TITLE}</title>
      </Helmet>
      <GitLiveLogo />
      <IonText color="light">
        Go to{' '}
        <strong>
          <a href="https://git.live">git.live</a>
        </strong>
      </IonText>
    </section>
  );
}
